import { REQUEST_CONFIGS_KEYS } from '@services/constants'
import Breakpoints from '@utils/breakpoints'
import { Colors } from '@utils/css-variables'
import { CheckboxList, RadioList, SelectList } from '@utils/request'
import { makeClasses } from '@utils/styles'

type Classes = {
	button: string
	outlinedButton: string
	fieldsContainer: string
	buttonContainer: string
	fileHelperSection: string
	fileContainer: string
	inputContainer: string
	checkbox2: string
	checkbox2Label: string
	checkbox2Container: string
	checkboxWrapper: string
	adresseBlock: string
	h5: string
	h6: string
	greyBackgroundBlock: string
	detailscontainer: string
	subContent: string
	reducedMarginBottom: string
	image: string
}

export const classes: Classes = makeClasses({
	button: {
		display: 'inline-block',
		padding: '10px 20px',
		fontSize: '13px',
		fontWeight: '500',
		color: Colors.white,
		lineHeight: '1em',
		borderRadius: '23px',
		transition: 'all 0.35s ease',
		MsTransition: 'all 0.35s ease',
		background: Colors.secondary,
		border: 'none',
		cursor: 'pointer',
		'&:hover': {
			background: Colors.darkBlue2,
			borderColor: Colors.darkBlue2,
			color: Colors.white
		}
	},
	outlinedButton: {
		background: 'none',
		border: `1px solid ${Colors.secondary} !important`,
		color: Colors.secondary
	},
	fieldsContainer: {
		[Breakpoints.minWidth('md')]: {
			display: 'grid',
			columnGap: '20px',
			gridTemplateColumns: '1fr 1fr',
			alignItems: 'end'
		}
	},
	buttonContainer: {
		display: 'flex',
		width: 'fit-content',
		columnGap: '4px'
	},
	fileHelperSection: {
		background: Colors.darkWhite,
		padding: '30px',
		marginBottom: '15px'
	},
	fileContainer: {
		'.blue-bullets-list': {
			ul: {
				padding: '0px 15px 0px 20px'
			}
		}
	},
	inputContainer: {
		marginBottom: '20px'
	},

	checkbox2: {
		width: 'fit-content',
		position: 'absolute',
		verticalAlign: 'baseline',
		clip: 'rect(1px, 1px, 1px, 1px)'
	},
	checkbox2Label: {
		fontSize: '16px',
		padding: '0',
		color: Colors.lightBlack,
		position: 'relative',
		paddingLeft: '27px',
		fontWeight: 'normal',
		cursor: 'pointer',
		lineHeight: '17px',
		':before': {
			content: "''",
			position: 'absolute',
			top: '0',
			left: '0',
			width: '16px',
			height: '16px',
			border: `1px solid ${Colors.lightGrey3}`,
			background: Colors.white,
			outline: 'none !important'
		},
		':after': {
			content: "''",
			position: 'absolute',
			top: '4px',
			left: '4px',
			width: '10px',
			height: '10px',
			background: Colors.secondary,
			outline: 'none',
			opacity: '0',
			transition: 'all .15s ease-out'
		}
	},
	checkbox2Container: {
		marginTop: '-15px',
		marginBottom: '15px',
		'& input[value=true] ~ label:after': {
			opacity: '.99'
		}
	},
	checkboxWrapper: {
		display: 'block',
		margin: '0 0 5px 0',
		background: Colors.ligthGrey2,
		border: `1px solid ${Colors.greyAlto}`,
		padding: '14px 12px'
	},
	adresseBlock: {
		border: `1px solid ${Colors.greyAlto}`,
		padding: '20px 25px',
		marginBottom: '10px',
		'& div': {
			alignItems: 'start !important'
		}
	},
	h5: {
		fontSize: '20px',
		fontWeight: '600',
		margin: '15px 0 10px 0'
	},
	h6: {
		color: Colors.secondary,
		margin: '20px 0 15px',
		fontSize: '18px',
		fontWeight: 500,
		lineHeight: 1.2
	},
	greyBackgroundBlock: {
		background: Colors.darkWhite,
		padding: '15px 30px'
	},
	detailscontainer: {
		display: 'grid',
		alignItems: 'start',
		gridTemplateColumns: '50%43%',
		columnGap: '7%',
		[Breakpoints.maxWidth('lg')]: {
			gridTemplateColumns: '45%46%',
			columnGap: '12%'
		},
		[Breakpoints.maxWidth('md')]: {
			gridTemplateColumns: '100%',
			'& img': {
				marginTop: '15px !important',
				width: '80% !important'
			}
		},
		[Breakpoints.maxWidth('sm')]: {
			'& img': {
				width: '100% !important'
			}
		},
		lineHeight: '1.62em',
		// fontSize: '16px',
		color: Colors.lightBlack,
		'& img': {
			width: '100%',
			verticalAlign: 'middle',
			margin: 'auto'
		},
		'& ul': {
			paddingLeft: '18px',
			margin: 0,
			'& li::marker': {
				color: Colors.secondary
			}
		}
	},
	subContent: {
		display: 'grid',
		columnGap: '15px',
		rowGap: '10px',
		gridTemplateColumns: '10rem auto',
		alignItems: 'end',
		[Breakpoints.maxWidth('md')]: {
			gridTemplateColumns: '2fr auto'
		},
		[Breakpoints.maxWidth('sm')]: {
			gridTemplateColumns: '2fr auto'
		},
		[Breakpoints.minWidth('md')]: {
			'& span': {
				'white-space': 'nowrap'
			}
		}
	},
	reducedMarginBottom: {
		marginBottom: '18px'
	},
	image: {
		[Breakpoints.maxWidth('md')]: {
			width: '35%'
		}
	}
})

// const { pageAssets } = requestForm()

export const isGR7_1RenovationOrDevelopment = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit.GR7_1RenovationOrDevelopment

export const isGR7_2RequestOccupation = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit.GR7_2RequestOccupation

export const isGR7_3HomeOfficeOrBusiness = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit.GR7_3HomeOfficeOrBusiness

export const isGR7_4InstallationOfEnseigne = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit.GR7_4InstallationOfEnseigne

// to delete
export const isBalconyOrPorchPermitGR6_1 = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_1BalconyOrPorch
export const isResidentialLandPermitGR6_2 = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_2ResidentialLand

export const isResidentialLandPermitGR6_5 = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_5Divers

// IndustrialCommercialOrAgriculturalUsePermitForm
// commercialPermit
// Case 1 = "Rénovation et aménagement d'un local (industriel, commercial, institutionnel ou agricole)"
// Description: "Demande de permis pour des travaux de modification ou d’aménagement intérieur ou extérieur d’un local industriel, commercial, institutionnel ou agricole."
// Case 2 = "Demande d'occupation d'un local (industriel, commercial, institutionnel ou agricole)"
// Description: "Demande pour obtenir un certificat d’occupation pour un nouveau local, un usage temporaire, un changement d’usage, une modification de superficie, ou l’ajout d’un usage additionnel ou conditionnel à un local existant."
// Case 3 = "Bureau à domicile ou commerce dans un bâtiment résidentiel"
// Description: "Demande pour exercer des activités administratives ou de formation, pour offrir des services à domicile ou exploiter une résidence pour hébergement ou tourisme dans un bâtiment résidentiel."
// Case 4 = "Installation d'une enseigne"
// Description: "Demande pour l’installation d’une ou des enseignes sur un bâtiment ou détachées de celui-ci."
export const radioListWhatToDo = (pageAssets): RadioList[] => [
	{
		label: pageAssets?.request_form_commercialPermit_whatToDo_firstOption,
		value:
			REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
				.GR7_1RenovationOrDevelopment,
		key: 'request_form_commercialPermit_whatToDo_firstOption',
		extraText:
			pageAssets?.request_form_commercialPermit_whatToDo_firstOption_extraText
	},
	{
		label: pageAssets?.request_form_commercialPermit_whatToDo_secondOption,
		value: REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit.GR7_2RequestOccupation,
		key: 'request_form_commercialPermit_whatToDo_secondOption',
		extraText:
			pageAssets?.request_form_commercialPermit_whatToDo_secondOption_extraText
	},
	{
		label: pageAssets?.request_form_commercialPermit_whatToDo_thirdOption,
		value:
			REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit.GR7_3HomeOfficeOrBusiness,
		key: 'request_form_commercialPermit_whatToDo_thirdOption',
		extraText:
			pageAssets?.request_form_commercialPermit_whatToDo_thirdOption_extraText
	},
	{
		label: pageAssets?.request_form_commercialPermit_whatToDo_fourthOption,
		value:
			REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit.GR7_4InstallationOfEnseigne,
		key: 'request_form_commercialPermit_whatToDo_fourthOption',
		extraText:
			pageAssets?.request_form_commercialPermit_whatToDo_fourthOption_extraText
	}
]

export const radioListRequestAs = (pageAssets): RadioList[] => {
	return [
		{
			label: pageAssets?.request_form_individual,
			value: REQUEST_CONFIGS_KEYS.requestAs.individual,
			key: 'request_form_individual'
		},
		{
			label: pageAssets?.request_form_entreprise,
			value: REQUEST_CONFIGS_KEYS.requestAs.entreprise,
			key: 'request_form_entreprise'
		},
		{
			label: pageAssets?.request_form_entrepreneur_or_manager,
			value: REQUEST_CONFIGS_KEYS.requestAs.entrepreneur_or_manager,
			key: 'request_form_entrepreneur_or_manager'
		}
	]
}

export const radioListYesNo = (pageAssets): RadioList[] => [
	{
		label: pageAssets.request_form_select_yes,
		value: 'true',
		key: 'request_form_select_yes'
	},
	{
		label: pageAssets.request_form_select_no,
		value: 'false',
		key: 'request_form_select_no'
	}
]

// STEP 2
export const radioListAddressOption = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets.request_form_addressInfoSection_addressOption_secondOption_label,
		value: REQUEST_CONFIGS_KEYS.researchType.cadastralNumber,
		key: 'request_form_addressInfoSection_addressOption_secondOption_label'
	},
	{
		label:
			pageAssets.request_form_addressInfoSection_addressOption_firstOption_label,
		value: REQUEST_CONFIGS_KEYS.researchType.address,
		key: 'request_form_addressInfoSection_addressOption_firstOption_label'
	}
]

// STEP 3
export const radioListMainUseOfExistingBuildingCommercialPermit = (
	pageAssets
): RadioList[] => [
	{
		label:
			pageAssets?.request_form_commercialPermit_mainUseOfNewBuilding_residential,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.residential,
		key: 'request_form_commercialPermit_mainUseOfNewBuilding_residential',
		extraText:
			pageAssets?.request_form_commercialPermit_mainUseOfNewBuilding_residential_extraText
	},
	{
		label:
			pageAssets?.request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_industrial,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.industrial,
		key: 'request_form_commercialPermit_mainUseOfExistingBuilding_industrial',
		extraText:
			pageAssets?.request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_industrial_extraText
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_installationType_commercial,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.commercial,
		key: 'request_form_commercialPermit_installationType_commercial',
		extraText:
			pageAssets?.request_form_commercialPermit_installationType_commercial_extraText
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_installationType_institutional,
		value:
			REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.institutional,
		key: 'request_form_commercialPermit_installationType_institutional',
		extraText:
			pageAssets?.request_form_commercialPermit_installationType_institutional_extraText
	},
	{
		label: pageAssets?.request_form_commercialPermit_installationType_mixed,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.mixed,
		key: 'request_form_commercialPermit_installationType_mixed',
		extraText:
			pageAssets?.request_form_commercialPermit_installationType_mixed_extraText
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_installationType_agricultural,
		value:
			REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.agricultural,
		key: 'request_form_commercialPermit_installationType_agricultural',
		extraText:
			pageAssets?.request_form_commercialPermit_installationType_agricultural_extraText
	}
]

// STEP 3
export const radioListProjectedUse = (pageAssets): RadioList[] => [
	// {
	// 	label:
	// 		pageAssets?.request_form_commercialPermit_mainUseOfNewBuilding_residential,
	// 	value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.residential,
	// 	key: 'request_form_commercialPermit_mainUseOfNewBuilding_residential',
	// 	extraText:
	// 		pageAssets?.request_form_commercialPermit_mainUseOfNewBuilding_residential_extraText
	// },
	{
		label:
			pageAssets?.request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_industrial,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.industrial,
		key: 'request_form_commercialPermit_mainUseOfExistingBuilding_industrial'
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_installationType_commercial,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.commercial,
		key: 'request_form_commercialPermit_installationType_commercial'
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_installationType_institutional,
		value:
			REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.institutional,
		key: 'request_form_commercialPermit_installationType_institutional'
	},
	{
		label: pageAssets?.request_form_commercialPermit_installationType_mixed,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.mixed,
		key: 'request_form_commercialPermit_installationType_mixed'
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_installationType_agricultural,
		value:
			REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingCommercial.agricultural,
		key: 'request_form_commercialPermit_installationType_agricultural'
	}
]

export const radioListMainUseOfExistingBuildingCommercialPermit2 = (
	pageAssets
): RadioList[] => [
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfNewBuilding_option1,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingForParking.firstOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_mainUseOfNewBuilding_option1',
		extraText:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfNewBuilding_option1_extraText
	},
	{
		label:
			pageAssets?.request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_option2,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.secondOption,
		key: 'request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_option2',
		extraText:
			pageAssets?.request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_option2_extraText
	},
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfExistingBuilding_option4,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingForParking.thirdOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_mainUseOfExistingBuilding_option4',
		extraText:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfExistingBuilding_option4_extraText
	}
]

export const radioListMainUseOfExistingBuildingCommercialPermit3 = (
	pageAssets
): RadioList[] => [
	{
		label:
			pageAssets?.request_form_commercialPermit_mainUseOfNewBuilding_residential,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingForParking.firstOption,
		key: 'request_form_commercialPermit_mainUseOfNewBuilding_residential',
		extraText:
			pageAssets?.request_form_commercialPermit_mainUseOfNewBuilding_residential_extraText
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_mainUseOfNewBuilding_agricol,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.secondOption,
		key: 'request_form_commercialPermit_mainUseOfNewBuilding_agricol',
		extraText:
			pageAssets?.request_form_commercialPermit_mainUseOfNewBuilding_agricol_extraText
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_emptyLot,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingForParking.thirdOption,
		key: 'request_form_landDevWorkPermit_useOfBuildingBoat_emptyLot',
		extraText:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_emptyLot_extraText
	}
]

// **********************************************************************
// **********************************************************************
// **********************************************************************
// **********************************************************************

export const radioListTypesOfWorkRenovation = (pageAssets): CheckboxList[] => [
	{
		label:
			pageAssets?.request_form_commerialPermit_typesOfWorkRenovation_interior,
		key: 'request_form_commerialPermit_typesOfWorkRenovation_interior',
		value: REQUEST_CONFIGS_KEYS.typesOfWork.firstOption,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_commerialPermit_typesOfWorkRenovation_exterior,
		key: 'request_form_commerialPermit_typesOfWorkRenovation_exterior',
		value: REQUEST_CONFIGS_KEYS.typesOfWork.secondOption,
		checked: false
	}
]

// !Important
export const isRenovationSectionA = (value) => {
	return value?.includes(REQUEST_CONFIGS_KEYS.typesOfWork.firstOption)
}

export const isRenovationSectionB = (value) => {
	return value?.includes(REQUEST_CONFIGS_KEYS.typesOfWork.secondOption)
}

// Dimensions *****

// Measurement unit m or ft
export const radioListMeasurementUnit = (pageAssets): RadioList[] => [
	{
		label: pageAssets?.request_form_meters,
		value: REQUEST_CONFIGS_KEYS.measurement_unit.meters_unit,
		key: 'request_form_meters'
	},
	{
		label: pageAssets?.request_form_foot,
		value: REQUEST_CONFIGS_KEYS.measurement_unit.foot_unit,
		key: 'request_form_foot'
	}
]

// Measurement unit m² or ft²
export const radioListMeasurement2Unit = (pageAssets): RadioList[] => [
	{
		label: pageAssets?.request_form_meters2,
		value: REQUEST_CONFIGS_KEYS.measurement_unit.meters_unit,
		key: 'request_form_meters2'
	},
	{
		label: pageAssets?.request_form_foot2,
		value: REQUEST_CONFIGS_KEYS.measurement_unit.foot_unit,
		key: 'request_form_foot2'
	}
]

export const radioListWhoWillBeInChargeOfWork = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_firstOption,
		value: REQUEST_CONFIGS_KEYS.whoWillBeInChargeOfWork.firstOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_firstOption'
	},
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_secondOption,
		value: REQUEST_CONFIGS_KEYS.whoWillBeInChargeOfWork.secondOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_secondOption'
	},
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_thirdOption,
		value: REQUEST_CONFIGS_KEYS.whoWillBeInChargeOfWork.thirdOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_thirdOption'
	}
]

// **********************************************************************
// **********************************************************************
// **********************************************************************
// **********************************************************************
// Case 1 ="Obtenir un certificat d'occupation pour un nouveau local"
// Case 2 ="Obtenir un certificat d'occupation pour l'usage temporaire d'un local ou d'un terrain"
// Case 3= "Faire un changement d'usage pour un local existant"
// Case 4= "Modifier la superficie (agrandissement ou réduction) d'un local existant"
// Case 5= "Ajouter un usage additionnel à un local existant"
// Case 6= "Ajouter un usage conditionnel à un local existant"
export const radioListTypesOfWorkOccupationOptions = (
	pageAssets
): RadioList[] => [
	{
		label: pageAssets?.request_form_commerialPermit_occupation_newLocal,
		value: REQUEST_CONFIGS_KEYS.occupationOptions.newLocal,
		key: 'request_form_commerialPermit_occupation_newLocal'
	},
	{
		label: pageAssets?.request_form_commerialPermit_occupation_temporaryUse,
		value: REQUEST_CONFIGS_KEYS.occupationOptions.temporaryUse,
		key: 'request_form_commerialPermit_occupation_temporaryUse'
	},
	{
		label: pageAssets?.request_form_commerialPermit_occupation_changeOfUse,
		value: REQUEST_CONFIGS_KEYS.occupationOptions.changeOfUse,
		key: 'request_form_commerialPermit_occupation_changeOfUse'
	},
	{
		label: pageAssets?.request_form_commerialPermit_occupation_modifyArea,
		value: REQUEST_CONFIGS_KEYS.occupationOptions.modifyArea,
		key: 'request_form_commerialPermit_occupation_modifyArea'
	},
	{
		label: pageAssets?.request_form_commerialPermit_occupation_additionalUse,
		value: REQUEST_CONFIGS_KEYS.occupationOptions.additionalUse,
		key: 'request_form_commerialPermit_occupation_additionalUse'
	},
	{
		label: pageAssets?.request_form_commerialPermit_occupation_conditionalUse,
		value: REQUEST_CONFIGS_KEYS.occupationOptions.conditionalUse,
		key: 'request_form_commerialPermit_occupation_conditionalUse'
	}
]

export const isOccupationSectionA = (value) => {
	return [
		REQUEST_CONFIGS_KEYS.occupationOptions.newLocal,
		REQUEST_CONFIGS_KEYS.occupationOptions.changeOfUse,
		REQUEST_CONFIGS_KEYS.occupationOptions.modifyArea,
		REQUEST_CONFIGS_KEYS.occupationOptions.additionalUse,
		REQUEST_CONFIGS_KEYS.occupationOptions.conditionalUse
	]?.includes(value)
}

export const isCase1SectionA = (value) =>
	value === REQUEST_CONFIGS_KEYS.occupationOptions.newLocal
export const isCase3SectionA = (value) =>
	value === REQUEST_CONFIGS_KEYS.occupationOptions.changeOfUse
export const isCase4SectionA = (value) =>
	value === REQUEST_CONFIGS_KEYS.occupationOptions.modifyArea
export const isCase5SectionA = (value) =>
	value === REQUEST_CONFIGS_KEYS.occupationOptions.additionalUse
export const isCase6SectionA = (value) =>
	value === REQUEST_CONFIGS_KEYS.occupationOptions.conditionalUse
export const isCase3or5or6SectionA = (value) =>
	isCase3SectionA(value) || isCase5SectionA(value) || isCase6SectionA(value)

export const isOccupationSectionB = (value) => {
	return [REQUEST_CONFIGS_KEYS.occupationOptions.temporaryUse]?.includes(value)
}

export const isOccupationSectionC = (value) => {
	return [REQUEST_CONFIGS_KEYS.occupationOptions.conditionalUse]?.includes(
		value
	)
}

export const isOccupationSectionD = (value) =>
	isOccupationSectionA(value) || isOccupationSectionB(value)

export const isOccupationSectionE = (value) => value !== ''

// Libellé "Usage projeté du nouveau local"
// Utiliser une liste déroulante avec les options suivantes:
// Choix 1="Commerces et services (C)"
// Choix 2="Public, institutionnel et communautaire (P)"
// Choix 3="Récréation (R)"
// Choix 4="Industrie (I)"
// Choix 5="Équipement de service public (E)"
// Choix 6="Agricole (A)"
export const selectListProjectedUseNewOccupation = (
	pageAssets
): SelectList[] => [
	{
		label: '',
		value: '',
		key: ''
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_occupationUse_commerceAndServices,
		value: REQUEST_CONFIGS_KEYS.projectedUseNewOccupation.commerceAndServices,
		key: 'request_form_commercialPermit_occupationUse_commerceAndServices'
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_occupationUse_publicInstitutionalCommunity,
		value:
			REQUEST_CONFIGS_KEYS.projectedUseNewOccupation
				.publicInstitutionalCommunity,
		key: 'request_form_commercialPermit_occupationUse_publicInstitutionalCommunity'
	},
	{
		label: pageAssets?.request_form_commercialPermit_occupationUse_recreation,
		value: REQUEST_CONFIGS_KEYS.projectedUseNewOccupation.recreation,
		key: 'request_form_commercialPermit_occupationUse_recreation'
	},
	{
		label: pageAssets?.request_form_commercialPermit_occupationUse_industry,
		value: REQUEST_CONFIGS_KEYS.projectedUseNewOccupation.industry,
		key: 'request_form_commercialPermit_occupationUse_industry'
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_occupationUse_publicServiceEquipment,
		value:
			REQUEST_CONFIGS_KEYS.projectedUseNewOccupation.publicServiceEquipment,
		key: 'request_form_commercialPermit_occupationUse_publicServiceEquipment'
	},
	{
		label: pageAssets?.request_form_commercialPermit_occupationUse_agricultural,
		value: REQUEST_CONFIGS_KEYS.projectedUseNewOccupation.agricultural,
		key: 'request_form_commercialPermit_occupationUse_agricultural'
	}
]

// Libellé "Usage actuel du local"
// Utiliser une liste déroulante avec les mêmes options que la question 9
// Choix 1="Habitation (H)"
// Choix 2="Commerces et services (C)"***
// Choix 3="Public, institutionnel et communautaire (P)"***
// Choix 4="Récréation (R)"**
// Choix 5="Industrie (I)"***
// Choix 6="Équipement de service public (E)"***
// Choix 7="Agricole (A)"***
// Choix 8="Vacant"
// Choix 9="Inconnu"
export const selectListCurrentUseOccupation = (pageAssets): SelectList[] => [
	{
		label: '',
		value: '',
		key: ''
	},
	{
		label: pageAssets?.request_form_commercialPermit_occupationUse_habitation,
		value: REQUEST_CONFIGS_KEYS.currentUseOccupation.habitation,
		key: 'request_form_commercialPermit_occupationUse_habitation'
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_occupationUse_commerceAndServices,
		value: REQUEST_CONFIGS_KEYS.currentUseOccupation.commerceAndServices,
		key: 'request_form_commercialPermit_occupationUse_commerceAndServices'
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_occupationUse_publicInstitutionalCommunity,
		value:
			REQUEST_CONFIGS_KEYS.currentUseOccupation.publicInstitutionalCommunity,
		key: 'request_form_commercialPermit_occupationUse_publicInstitutionalCommunity'
	},
	{
		label: pageAssets?.request_form_commercialPermit_occupationUse_recreation,
		value: REQUEST_CONFIGS_KEYS.currentUseOccupation.recreation,
		key: 'request_form_commercialPermit_occupationUse_recreation'
	},
	{
		label: pageAssets?.request_form_commercialPermit_occupationUse_industry,
		value: REQUEST_CONFIGS_KEYS.currentUseOccupation.industry,
		key: 'request_form_commercialPermit_occupationUse_industry'
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_occupationUse_publicServiceEquipment,
		value: REQUEST_CONFIGS_KEYS.currentUseOccupation.publicServiceEquipment,
		key: 'request_form_commercialPermit_occupationUse_publicServiceEquipment'
	},
	{
		label: pageAssets?.request_form_commercialPermit_occupationUse_agricultural,
		value: REQUEST_CONFIGS_KEYS.currentUseOccupation.agricultural,
		key: 'request_form_commercialPermit_occupationUse_agricultural'
	},
	{
		label: pageAssets?.request_form_commercialPermit_occupationUse_vacant,
		value: REQUEST_CONFIGS_KEYS.currentUseOccupation.vacant,
		key: 'request_form_commercialPermit_occupationUse_vacant'
	},
	{
		label: pageAssets?.request_form_commercialPermit_occupationUse_unknown,
		value: REQUEST_CONFIGS_KEYS.currentUseOccupation.unknown,
		key: 'request_form_commercialPermit_occupationUse_unknown'
	}
]

// Utiliser des boutons radios avec les options suivantes:
// Case 1= "Local"
// Case 2= "Terrain"
export const radioIsLocalOrTerrainOptions = (pageAssets) => [
	{
		label: pageAssets?.request_form_commercialPermit_isLocalOrTerrain_local,
		value: REQUEST_CONFIGS_KEYS.isLocalOrTerrain.local,
		key: 'request_form_commercialPermit_isLocalOrTerrain_local'
	},
	{
		label: pageAssets?.request_form_commercialPermit_isLocalOrTerrain_terrain,
		value: REQUEST_CONFIGS_KEYS.isLocalOrTerrain.terrain,
		key: 'request_form_commercialPermit_isLocalOrTerrain_terrain'
	}
]

// Libellé "Quel type d'activités souhaitez-vous effectuer?"
// Utiliser des boutons radios avec les options suivantes:
// Si la case 1 de la Question 13 est cochée:
// Case 1="Bureau de vente ou de location immobilière "
// Case 2="Bureau de chantier, services et support liés à des travaux de construction "
// Case 9="Autres"
// Si la case 9 a été cochée, mettre une case libellée "Veuillez préciser", 50 caractères alphanumériques
// Si la case 2 de la Question 13 est cochée:
// Case 3="Vente extérieur d'arbres et de décoration de Noël"
// Case 4="Marché public ou marché de quartier extérieur"
// Case 5="Vente extérieure de produits de la ferme en milieu urbain"
// Case 6="Vente extérieure de potées fleuries à l'occasion de la fête de Pâques et de la fête des Mères"
// Case 7="Activité extérieure de promotion commerciale"
// Case 8="Événement spécial ou foire spectacle extérieur, festival, fête populaire, marché de Noël, fête foraine et cirque"
// Case 9="Autres"
// Si la case 9 a été cochée, mettre une case libellée "Veuillez préciser", 50 caractères alphanumériques
export const radioListOccupationActivityTypeCase1 = (
	pageAssets
): RadioList[] => [
	{
		label: pageAssets?.request_form_occupationActivityType_bureauVente,
		value: REQUEST_CONFIGS_KEYS.occupationActivityType.bureauVente,
		key: 'request_form_occupationActivityType_bureauVente'
	},
	{
		label: pageAssets?.request_form_occupationActivityType_bureauChantier,
		value: REQUEST_CONFIGS_KEYS.occupationActivityType.bureauChantier,
		key: 'request_form_occupationActivityType_bureauChantier'
	},
	{
		label: pageAssets?.request_form_occupationActivityType_autres,
		value: REQUEST_CONFIGS_KEYS.occupationActivityType.autres,
		key: 'request_form_occupationActivityType_autres'
	}
]

export const radioListOccupationActivityTypeCase2 = (
	pageAssets
): RadioList[] => [
	{
		label:
			pageAssets?.request_form_occupationActivityType_venteExterieurArbresDecorationNoel,
		value:
			REQUEST_CONFIGS_KEYS.occupationActivityType
				.venteExterieurArbresDecorationNoel,
		key: 'request_form_occupationActivityType_venteExterieurArbresDecorationNoel'
	},
	{
		label:
			pageAssets?.request_form_occupationActivityType_marchePublicOuMarcheQuartierExterieur,
		value:
			REQUEST_CONFIGS_KEYS.occupationActivityType
				.marchePublicOuMarcheQuartierExterieur,
		key: 'request_form_occupationActivityType_marchePublicOuMarcheQuartierExterieur'
	},
	{
		label:
			pageAssets?.request_form_occupationActivityType_venteExterieureProduitsFermeMilieuUrbain,
		value:
			REQUEST_CONFIGS_KEYS.occupationActivityType
				.venteExterieureProduitsFermeMilieuUrbain,
		key: 'request_form_occupationActivityType_venteExterieureProduitsFermeMilieuUrbain'
	},
	{
		label:
			pageAssets?.request_form_occupationActivityType_venteExterieurePoteesFleuriesOccasionPaquesFeteMeres,
		value:
			REQUEST_CONFIGS_KEYS.occupationActivityType
				.venteExterieurePoteesFleuriesOccasionPaquesFeteMeres,
		key: 'request_form_occupationActivityType_venteExterieurePoteesFleuriesOccasionPaquesFeteMeres'
	},
	{
		label:
			pageAssets?.request_form_occupationActivityType_activiteExterieurePromotionCommerciale,
		value:
			REQUEST_CONFIGS_KEYS.occupationActivityType
				.activiteExterieurePromotionCommerciale,
		key: 'request_form_occupationActivityType_activiteExterieurePromotionCommerciale'
	},
	{
		label: pageAssets?.request_form_occupationActivityType_evenementSpecial,
		value: REQUEST_CONFIGS_KEYS.occupationActivityType.evenementSpecial,
		key: 'request_form_occupationActivityType_evenementSpecial'
	},
	{
		label: pageAssets?.request_form_occupationActivityType_autres,
		value: REQUEST_CONFIGS_KEYS.occupationActivityType.autres,
		key: 'request_form_occupationActivityType_autres'
	}
]

// Utiliser des cases à cocher avec les options suivantes:
// Case 1="Bar "
// Case 2="Spectacle "
// Case 3="Danse"
// Case 4="Autre"
// radioListAlcoholPermitActivityType
export const radioListAlcoholPermitActivityType = (pageAssets): RadioList[] => [
	{
		label: pageAssets?.request_form_alcoholPermitActivityType_bar,
		value: REQUEST_CONFIGS_KEYS.alcoholPermitActivityType.bar,
		key: 'request_form_alcoholPermitActivityType_bar'
	},
	{
		label: pageAssets?.request_form_alcoholPermitActivityType_spectacle,
		value: REQUEST_CONFIGS_KEYS.alcoholPermitActivityType.spectacle,
		key: 'request_form_alcoholPermitActivityType_spectacle'
	},
	{
		label: pageAssets?.request_form_alcoholPermitActivityType_danse,
		value: REQUEST_CONFIGS_KEYS.alcoholPermitActivityType.danse,
		key: 'request_form_alcoholPermitActivityType_danse'
	},
	{
		label: pageAssets?.request_form_alcoholPermitActivityType_autre,
		value: REQUEST_CONFIGS_KEYS.alcoholPermitActivityType.autre,
		key: 'request_form_alcoholPermitActivityType_autre'
	}
]

export const radioListOwnerOrRenter = (pageAssets): RadioList[] => [
	{
		label: pageAssets.select_ownerStatus_owner,
		value: REQUEST_CONFIGS_KEYS.tenantOrOwner.owner,
		key: 'select_ownerStatus_owner'
	},
	{
		label: pageAssets.select_ownerStatus_tenant,
		value: REQUEST_CONFIGS_KEYS.tenantOrOwner.tenant,
		key: 'select_ownerStatus_tenant'
	}
]

// Utiliser des boutons radio avec les options suivantes:
// Case 1 ="Bureau ou activité administrative ou de formation à domicile"
// Description: Services professionnels, techniques ou d’affaires.
// Case 2 ="Services à domicile"
// Description: Services offerts directement à domicile. Il peut s’agir d’un service photographique, de soins esthétiques personnels (beauté, coiffure, capillaire, etc.), de séances de massothérapie ou de soins professionnels de santé.
// Case 3 ="Résidence pour hébergement et tourisme"
// Description: Offre de services d'hébergement offerte à domicile pour une clientèle de passage.
// Case 4 = "Autres"
export const radioListHomeOfficeOrBusinessType = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_commercialPermit_homeOfficeOrBusinessType_administrativeActivity,
		value: REQUEST_CONFIGS_KEYS.homeOfficeOrBusinessType.administrativeActivity,
		key: 'request_form_commercialPermit_homeOfficeOrBusinessType_administrativeActivity',
		extraText:
			pageAssets?.request_form_commercialPermit_homeOfficeOrBusinessType_administrativeActivity_extraText
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_homeOfficeOrBusinessType_servicesAtHome,
		value: REQUEST_CONFIGS_KEYS.homeOfficeOrBusinessType.servicesAtHome,
		key: 'request_form_commercialPermit_homeOfficeOrBusinessType_servicesAtHome',
		extraText:
			pageAssets?.request_form_commercialPermit_homeOfficeOrBusinessType_servicesAtHome_extraText
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_homeOfficeOrBusinessType_residenceForAccommodationAndTourism,
		value:
			REQUEST_CONFIGS_KEYS.homeOfficeOrBusinessType
				.residenceForAccommodationAndTourism,
		key: 'request_form_commercialPermit_homeOfficeOrBusinessType_residenceForAccommodationAndTourism',
		extraText:
			pageAssets?.request_form_commercialPermit_homeOfficeOrBusinessType_residenceForAccommodationAndTourism_extraText
	},
	{
		label:
			pageAssets?.request_form_commercialPermit_homeOfficeOrBusinessType_others,
		value: REQUEST_CONFIGS_KEYS.homeOfficeOrBusinessType.others,
		key: 'request_form_commercialPermit_homeOfficeOrBusinessType_others'
	}
]

// Case 1 ="Installation de nouvelle(s) enseigne(s)?"
// Case 2 = "Remplacement d'enseigne(s) existante(s)"
// Case 3 = "Installation de représentation(s) artistique(s) murale(s)
export const radioListTypesOfWorkEnseigne = (pageAssets): CheckboxList[] => [
	{
		label: pageAssets?.request_form_commerialPermit_typesOfWorkEnseigne_newSign,
		key: 'request_form_commerialPermit_typesOfWorkEnseigne_newSign',
		value: REQUEST_CONFIGS_KEYS.typesOfWorkEnseigne.newSign,
		checked: false,
		index: 0
	},
	{
		label:
			pageAssets?.request_form_commerialPermit_typesOfWorkEnseigne_replaceSign,
		key: 'request_form_commerialPermit_typesOfWorkEnseigne_replaceSign',
		value: REQUEST_CONFIGS_KEYS.typesOfWorkEnseigne.replaceSign,
		checked: false,
		index: 1
	},
	{
		label:
			pageAssets?.request_form_commerialPermit_typesOfWorkEnseigne_artisticWallRepresentation,
		key: 'request_form_commerialPermit_typesOfWorkEnseigne_artisticWallRepresentation',
		value: REQUEST_CONFIGS_KEYS.typesOfWorkEnseigne.artisticWallRepresentation,
		checked: false,
		index: 2
	}
]

export const isNewSignInstallation = (value): boolean => {
	return value?.includes(REQUEST_CONFIGS_KEYS.typesOfWorkEnseigne.newSign)
}
export const isReplaceSignInstallation = (value): boolean => {
	return value?.includes(REQUEST_CONFIGS_KEYS.typesOfWorkEnseigne.replaceSign)
}
export const isArtisticWallRepresentationInstallation = (value): boolean => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.typesOfWorkEnseigne.artisticWallRepresentation
	)
}
